import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import './HeaderMobile.scss';
import { useState } from 'react';
import { MenuMobile } from './MenuMobile';

export function HeaderMobile() {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const toggleMenu = () => setMenuIsOpen(!menuIsOpen);

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="app-header header-mobile">
      <div>
        <h1 className="lato-thin mb-0">LILIA</h1>
        <h1 className="lato-thin mb-0">FACIALISTE</h1>
        <p className="lato-thin">Paris</p>
      </div>
      <FontAwesomeIcon className="icon" icon={faBars} onClick={toggleMenu} />
      <MenuMobile
        isOpen={menuIsOpen}
        onClose={toggleMenu}
        scrollToSection={scrollToSection}
      />
    </header>
  );
}
